import Cookies from 'js-cookie';

/**
 * Cookie utility untuk mengelola auth token
 */

const TOKEN_KEY = 'venntix_token';
const USER_KEY = 'venntix_user';

/**
 * Simpan token ke cookie
 * @param token - Auth token yang akan disimpan
 * @param rememberMe - Jika true, cookie akan bertahan 7 hari, jika false akan session cookie
 */
export function saveTokenCookie(token: string, rememberMe: boolean = false): void {
    const options: Cookies.CookieAttributes = {
        path: '/', // Ensure cookie is accessible from all paths including middleware
        sameSite: 'lax', // CSRF protection
        ...(rememberMe ? { expires: 7 } : {})
    };
    Cookies.set(TOKEN_KEY, token, options);
    console.log('🍪 Cookie saved:', TOKEN_KEY, 'rememberMe:', rememberMe, 'options:', options);

    // Verify cookie was set
    const verify = Cookies.get(TOKEN_KEY);
    console.log('🔍 Verify cookie:', verify ? '✅ Found' : '❌ Not found');
}

/**
 * Ambil token dari cookie
 * @returns Token atau undefined jika tidak ada
 */
export function getTokenCookie(): string | undefined {
    return Cookies.get(TOKEN_KEY);
}

/**
 * Hapus token dari cookie
 */
export function removeTokenCookie(): void {
    Cookies.remove(TOKEN_KEY);
}

/**
 * Simpan user data ke cookie (optional, untuk quick access)
 * @param user - User data yang akan disimpan
 * @param rememberMe - Jika true, cookie akan bertahan 7 hari
 */
export function saveUserCookie(user: any, rememberMe: boolean = false): void {
    const options: Cookies.CookieAttributes = {
        path: '/',
        sameSite: 'lax',
        ...(rememberMe ? { expires: 7 } : {})
    };
    Cookies.set(USER_KEY, JSON.stringify(user), options);
}

/**
 * Ambil user data dari cookie
 * @returns User object atau null jika tidak ada
 */
export function getUserCookie(): any | null {
    const userStr = Cookies.get(USER_KEY);
    if (!userStr) return null;

    try {
        return JSON.parse(userStr);
    } catch (e) {
        return null;
    }
}

/**
 * Hapus user data dari cookie
 */
export function removeUserCookie(): void {
    Cookies.remove(USER_KEY);
}

/**
 * Clear semua auth cookies
 */
export function clearAuthCookies(): void {
    removeTokenCookie();
    removeUserCookie();
}
